<template>
  <el-form ref="ruleFormRef" style="max-width: 600px" :model="account" status-icon :rules="rules" label-width="auto" class="accountForm">
    <el-form-item label="账号" prop="username">
      <el-input v-model="account.username" type="input" autocomplete="off" />
    </el-form-item>
    <el-form-item label="密码" prop="password">
      <el-input v-model="account.password" type="password" autocomplete="off" show-password />
    </el-form-item>
    <el-form-item label="动态码" prop="captchaCode">
      <div class="captcha-row">
        <el-input v-model="account.captchaCode" placeholder="请输入计算结果" autocomplete="off" />
        <img v-if="captchaImg" class="captcha-img" :src="captchaImg" title="点击刷新" alt="验证码" @click="refreshCaptcha" />
        <div v-else class="captcha-img captcha-img--placeholder" title="点击刷新" @click="refreshCaptcha">加载中</div>
      </div>
    </el-form-item>
  </el-form>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'

import type { ElForm } from 'element-plus'
import { accountRules } from '@/views/login/config/account-config'
import localCache from '@/utils/cache'
import store from '@/store'
import { getMathCaptcha } from '@/api/admin/loginApi'
import { showErrorIfNeeded } from '@/utils/common-util'

const ruleFormRef = ref<InstanceType<typeof ElForm>>()
const captchaImg = ref('')

const account = reactive({
  username: localCache.getCache('username') ?? '',
  password: localCache.getCache('password') ?? '',
  captchaId: '',
  captchaCode: ''
})

const rules = accountRules

const refreshCaptcha = async () => {
  try {
    const res: any = await getMathCaptcha()
    const data = res?.data || {}
    account.captchaId = data.captchaId || ''
    captchaImg.value = data.img || ''
    account.captchaCode = ''
  } catch (error: any) {
    captchaImg.value = ''
    account.captchaId = ''
    showErrorIfNeeded(error, '获取验证码失败')
  }
}

const loginAction = (isKeepPassword: boolean) => {
  ruleFormRef.value?.validate(async (valid) => {
    if (!valid) return
    if (isKeepPassword) {
      localCache.setCache('username', account.username)
      localCache.setCache('password', account.password)
    } else {
      localCache.deleteCache('username')
      localCache.deleteCache('password')
    }
    try {
      await store.dispatch('login/accountLoginAction', {
        username: account.username,
        password: account.password,
        captchaId: account.captchaId,
        captchaCode: account.captchaCode
      })
    } catch {
      await refreshCaptcha()
    }
  })
}

onMounted(() => {
  refreshCaptcha()
})

defineExpose({
  loginAction,
  refreshCaptcha
})
</script>

<style scoped lang="less">
.captcha-row {
  display: flex;
  width: 100%;
  gap: 8px;
  align-items: center;

  .el-input {
    flex: 1;
  }

  .captcha-img {
    width: 130px;
    height: 48px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    object-fit: contain;
    background: #fff;
    flex-shrink: 0;

    &:hover {
      border-color: #409eff;
    }

    &--placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: #909399;
      background: #f5f7fa;
      user-select: none;
    }
  }
}
</style>
